import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthStore } from '@auth';
import { map, Observable, of, switchMap } from 'rxjs';
import { take } from 'rxjs/operators';

export const IsAllowForRoles = (allowRoles: Role[]): CanActivateFn => {
  return (): Observable<boolean | UrlTree> => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const userRoleList$ = authStore.userProfile$.pipe(
      take(1),
      map(user => {
        const unitRoles = Array.from(new Set(user.userUnits.map(it => it.role)));
        return user.isSuperAdmin ? [...unitRoles, 'SuperAdmin' as Role] : unitRoles;
      })
    );

    return userRoleList$.pipe(
      map(userRoles => userRoles.some(role => allowRoles.includes(role))),
      switchMap(isAllow => of(isAllow || router.createUrlTree(['/'])))
    );
  };
};
